import { lazy } from "react"

export { PolicyExceptionLinkRedirect } from "./components/organisms/PolicyExceptionLinkRedirect"
export { PolicyExceptionLayout } from "./components/templates/PolicyExceptionLayout"
export type {
  PolicyExceptionPageMode,
  PolicyExceptionPageProps
} from "./PolicyExceptionPage.types"

// Opened only from PR report links, so it stays out of the main bundle.
export const PolicyExceptionPage = lazy(() =>
  import("./PolicyExceptionPage").then((module) => ({
    default: module.PolicyExceptionPage
  }))
)
